import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from './Slider';
import polygonLogo from '../assets/polygon-logo.png';
import binanceLogo from '../assets/binance-logo.png';
import solanaLogo from '../assets/solana-logo.png';
import ethereumLogo from '../assets/ethereum-logo.png';
import trustScoreImage from '../assets/trust-score-img.png';
import { Link } from 'react-router-dom';
function CentalCard() {
  const navigate = useNavigate();
  
  const vaults = [
    {
      cardHeaderIcon: polygonLogo,
      cardHeaderTitle: 'USDC (USDC)',
      detailspan1: 'Liquidity',
      detailspan1value: '$60.00',
      detailspan2: 'Price',
      detailspan2value: '$67.72',
      detailspan3: 'Price Provider',
      detailspan3value: 'Ethereum',
      trustScoreSpan: 'Trust Score',
      trustScoreSpanValue: '8.1',
      TrustScoreImage: trustScoreImage,
    },
    {
      cardHeaderIcon: binanceLogo,
      cardHeaderTitle: 'SHIBA INU (SHIB)',
      detailspan1: 'Liquidity',
      detailspan1value: '$60.00',
      detailspan2: 'Price',
      detailspan2value: '$67.72',
      detailspan3: 'Price Provider',
      detailspan3value: 'Ethereum',
      trustScoreSpan: 'Trust Score',
      trustScoreSpanValue: '8.1',
      TrustScoreImage: trustScoreImage,
    },
    {
      cardHeaderIcon: solanaLogo,
      cardHeaderTitle: 'TRON',
      detailspan1: 'Liquidity',
      detailspan1value: '$60.00',
      detailspan2: 'Price',
      detailspan2value: '$67.72',
      detailspan3: 'Price Provider',
      detailspan3value: 'Ethereum',
      trustScoreSpan: 'Trust Score',
      trustScoreSpanValue: '8.1',
      TrustScoreImage: trustScoreImage,
    },
    {
        cardHeaderIcon: solanaLogo,
        cardHeaderTitle: 'TRON',
        detailspan1: 'Liquidity',
        detailspan1value: '$60.00',
        detailspan2: 'Price',
        detailspan2value: '$67.72',
        detailspan3: 'Price Provider',
        detailspan3value: 'Ethereum',
        trustScoreSpan: 'Trust Score',
        trustScoreSpanValue: '8.1',
        TrustScoreImage: trustScoreImage,
      },
      {
        cardHeaderIcon: solanaLogo,
        cardHeaderTitle: 'TRON',
        detailspan1: 'Liquidity',
        detailspan1value: '$60.00',
        detailspan2: 'Price',
        detailspan2value: '$67.72',
        detailspan3: 'Price Provider',
        detailspan3value: 'Ethereum',
        trustScoreSpan: 'Trust Score',
        trustScoreSpanValue: '8.1',
        TrustScoreImage: trustScoreImage,
      },
      {
        cardHeaderIcon: solanaLogo,
        cardHeaderTitle: 'TRON',
        detailspan1: 'Liquidity',
        detailspan1value: '$60.00',
        detailspan2: 'Price',
        detailspan2value: '$67.72',
        detailspan3: 'Price Provider',
        detailspan3value: 'Ethereum',
        trustScoreSpan: 'Trust Score',
        trustScoreSpanValue: '8.1',
        TrustScoreImage: trustScoreImage,
      },
      {
        cardHeaderIcon: solanaLogo,
        cardHeaderTitle: 'TRON',
        detailspan1: 'Liquidity',
        detailspan1value: '$60.00',
        detailspan2: 'Price',
        detailspan2value: '$67.72',
        detailspan3: 'Price Provider',
        detailspan3value: 'Ethereum',
        trustScoreSpan: 'Trust Score',
        trustScoreSpanValue: '8.1',
        TrustScoreImage: trustScoreImage,
      },
      {
        cardHeaderIcon: solanaLogo,
        cardHeaderTitle: 'TRON',
        detailspan1: 'Liquidity',
        detailspan1value: '$60.00',
        detailspan2: 'Price',
        detailspan2value: '$67.72',
        detailspan3: 'Price Provider',
        detailspan3value: 'Ethereum',
        trustScoreSpan: 'Trust Score',
        trustScoreSpanValue: '8.1',
        TrustScoreImage: trustScoreImage,
      },
      {
        cardHeaderIcon: solanaLogo,
        cardHeaderTitle: 'TRON',
        detailspan1: 'Liquidity',
        detailspan1value: '$60.00',
        detailspan2: 'Price',
        detailspan2value: '$67.72',
        detailspan3: 'Price Provider',
        detailspan3value: 'Ethereum',
        trustScoreSpan: 'Trust Score',
        trustScoreSpanValue: '8.1',
        TrustScoreImage: trustScoreImage,
      },
      
      
  ];

  return (
    <div className="invest-background">
        
      <div className="header-container">
        
        <div className="header-content">
        <h1 className="header-title">
  <Link to="/home" style={{ textDecoration: 'none', color: 'inherit' }}>Lookna</Link>
</h1>
          <h2 className="header-subtitle">
            FIND YOUR<span className="color-sp"> IDEAL INVESTMENT VAULT</span>
          </h2>
          <p className="header-description">
            Discover a range of investment options tailored to your needs, from automated solutions to customizable strategies.
          </p>
        </div>
        <div className="details-borders"></div>
      </div>

      {/* Use Slider Component */}
      <div className="vault-slider">
        {/* <h1>Centerlize Exchange</h1> */}
        <Slider items={vaults} />
      </div>
      <div className="vault-slider">
        {/* <h1>Centerlize Exchange</h1> */}
        <Slider items={vaults} />
      </div>
      <div className="vault-slider">
        {/* <h1>Centerlize Exchange</h1> */}
        <Slider items={vaults} />
      </div>
      <div className="vault-slider">
        {/* <h1>Centerlize Exchange</h1> */}
        <Slider items={vaults} />
      </div>
   
    </div>
  );
}

export default CentalCard;
